import axios from "axios";
import { Message, MessageBox } from "element-ui";
import store from "../store";
import { getToken } from "@/utils/auth";
import config from "./config.utils";
import domMessage from "./messageOnce";

// new 对象实例
const messageOnce = new domMessage();
// 创建axios实例
const service = axios.create({
  withCredentials: true,
  baseURL: config.apiPath.service, // api的base_url
  timeout: 60000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res.code !== 200) {
      messageOnce.error({
        message: res.message,
        type: "error"
      });
      // 401:未登录;
      if (res.code === 401) {
        store.dispatch("FedLogOut").then(() => {
          setTimeout(() => {
            location.reload();
          }, 500); // 为了重新实例化vue-router对象 避免bug
        });
      }
      return Promise.reject(res.data);
    } else {
      return response.data;
    }
  },
  error => {
    console.log("err --->" + error); // for debug
    messageOnce.error({
      message: error.message,
      type: "error"
    });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js